export default __webpack_public_path__ + "img/sent-icon.e304204a.svg";